export default "__VITE_ASSET__CCRX5qyv__"